import styled from 'styled-components'
import { FormInput } from 'shared/components/form/form-components'

const Container = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    ${FormInput} {
        font-weight: normal;
    }
`
export default Container
